import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    accessibleLabel: string;
    member: string;
    guest: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Accessible label for the user license type select */
            accessibleLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UserLicenseTypeSelect.accessibleLabel?c=2qqkmpk5uwg49", defaultMessage: "User seats" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Member label */
            member: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UserLicenseTypeSelect.member?c=m9y5ixy73rk5", defaultMessage: "Member" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Guest label */
            guest: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UserLicenseTypeSelect.guest?c=3dszhu21ezltw", defaultMessage: "Guest" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
